define(['angular'], function(angular) {


    /**
     * @class TpeService
     */
    function TpeService() {
        var self = this;

        /**
         * Special exception condition for TPE options that are not linked with TPE devices
         * @param  {Object}  option
         * @return {Boolean}
         */
        self.isOptionIndependant = function isOptionIndependant(option) {
            return option.reference === 'TPECABLE';
        };

        return self;
    }

    TpeService.$inject = [];

    angular.module('app.bdc.common.tpeService', []).factory('tpeService', TpeService);
});
